import { CountryCode } from '@/constants/countryCodes';
import type { Customer } from '@/types/checkout';
import { getCustomerCountry } from './customer';

/**
 * Countries whose shoppers get a taller purchased-items scroll window. Japan
 * asked for more of the cart to be visible without scrolling; every other
 * country keeps the default heights.
 *
 * Add a country here rather than branching at the call site — the row heights
 * themselves live with the other `max-h` classes in `PurchasedItems`.
 */
const COUNTRIES_WITH_EXTRA_ITEM_ROWS = [CountryCode.JAPAN];

/**
 * Whether the purchased-items list should reveal its taller row window for this
 * shopper. Resolves the country through {@link getCustomerCountry}, so the
 * BE-stamped `taxCountry` wins over the IP-derived fallback, and compares
 * case-insensitively.
 */
export const shouldShowExtraItemRows = (customer: Customer | null | undefined): boolean =>
  COUNTRIES_WITH_EXTRA_ITEM_ROWS.includes(getCustomerCountry(customer).toUpperCase() as CountryCode);
